import $ from 'jquery';
window.$ = window.jQuery = $;

$(document).on("change", ".vendorPostUrl", function()
{
	let title = $("#companyName").val().slice(0,80);
	let code = $("#companyName").val().replace(/[^a-zA-Z0-9]/g, '').substring(0, 4).toLowerCase();
	if (code.length < 4) 
	{
	    var appendCode = Math.random().toString(36).substring(2, 2 + (4 - code.length));
    	code += appendCode;
	}
	if(title.match(/^[\x00-\x7F]*$/) == null)
	{
		$('#companyStatus').text("Special characters except (@, #, $, % , ^, &, *, _) are not allowed");
		$('#companyName').addClass('is-invalid');
		$("#companyName").val('');
		$("#posturl").val('');
		$("#companyCode").val('');
	}
	else
	{
		let url = title.replace(/[^A-Z0-9]+/ig, '-');
		$("#posturl").val(url);
		$.ajax(
    	{
	        url: '/vendor/check/companycode/' + code,
	        type: 'GET',
	        success: function(response) 
	        {
	        	console.log(response);
	        	if(response == 1)
	        	{
	        		$("#companyCode").val(code);
	        		$('#companyCode').removeClass('is-invalid');
	        		$('#companyStatus').text('');
	        	}
	        	else
	        	{
	        		$("#companyCode").val("");
	        		$('#companyCode').addClass('is-invalid');
	        		$('#companyStatus').text('This company code already exists. Please enter a 4-character code to uniquely identify the company');
	        	}
	        },
	        error: function(xhr, status, error) 
	        {
	            console.error(error);
	        }
	    });
		$('#companyStatus').text("");
		$('#companyName').removeClass('is-invalid');
	}
});